// components/LoginModal.jsx

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import loginStyles from './LoginModal.module.css'; // Import specific styles for Login Modal
import blurStyles from '/styles/BlurBackground.module.css'; // Import styles for blur background
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'; // Correct import of the 'times circle' icon

const LoginModal = ({ isOpen, onClose }) => {
  const [modalContainer, setModalContainer] = useState(null);

  useEffect(() => {
    // Set up the modal container for the portal
    const container = document.getElementById('modal-root');
    setModalContainer(container);
  }, []);

  // Ensure the modal is only rendered when open and the container exists
  if (!isOpen || !modalContainer) return null;

  // Define the modal content
  const modalContent = (
    <div className={loginStyles['login-modal']} role="dialog" aria-modal="true" aria-labelledby="login-modal-title">
      <div className={loginStyles['login-modal-content']}>
        <div className={loginStyles['login-modal-url-bar-top']}>
          <div className={loginStyles['modal-url']}><center>ShuffleDB.com</center></div>
        </div>
        {/* Updated Close Button */}
        <button className={loginStyles['login-modal-close']} onClick={onClose} aria-label="Close modal">
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
        </button>
        <div id="login-modal-title" className={loginStyles['login-modal-title']}>
          Login
        </div>
        <div className={loginStyles['login-modal-body']}>
          <form>
            <input type="text" className={loginStyles['login-input']} placeholder="Email/Username" />
            <input type="password" className={loginStyles['login-input']} placeholder="Password" />
            <button type="submit" className={loginStyles['login-button']} aria-label="Log in">Log In</button>
          </form>
        </div>
        <div className={loginStyles['login-modal-url-bar-bottom']}>
          <div className={loginStyles['modal-url']}><center>ShuffleDB.com</center></div>
        </div>
      </div>
    </div>
  );

  // Render the modal using ReactDOM.createPortal to ensure it renders correctly
  return ReactDOM.createPortal(modalContent, modalContainer);
};

export default LoginModal;
